import './public-path'
import Vue from 'vue'
import Element from 'element-ui'
// import VueRouter from 'vue-router'
import App from './App.vue'
import router from '@/router'
import store from './store'
import Cookies from 'js-cookie'

import './styles/element-variables.scss'
import zhLang from 'element-ui/lib/locale/lang/zh-CN'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖

import { setToken } from './utils/auth'
import { getToken } from './utils/auth'

import './icons' // icon
import './permission' // permission control

Vue.config.productionTip = false

let instance = null;

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale: zhLang // 如果使用中文，无需设置，请删除
})

// 页面渲染方法
function render(props = {}) {
  const { container } = props;
  instance = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app');
}
 
// webpack打包公共文件路径
if (window.__POWERED_BY_QIANKUN__) {
  console.log("qiankun启动");
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}else{
	// 独立运行时就直接渲染
  console.log("独立运行时就直接渲染");
  render();
}

/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  console.log('[vue] vue app bootstraped');
}
 
/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props) {
  console.log('[vue] props from main framework主应用传递参数：', props);
  setToken(props.tokenData);
  console.log("token:",getToken());
  render(props);
}
 
/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount() {
  instance.$destroy();
  instance.$el.innerHTML = '';
  instance = null;
  // router = null;
}

export default instance;
